export default function ContactSection() {
  const handleApplyClick = () => {
    window.open('https://pump.fun/', '_blank');
  };

  const handleDiscordClick = () => {
    window.open('https://discord.gg/6QDpvwzn', '_blank');
  };

  const handleTwitterClick = () => {
    window.open('https://x.com/TheDegenZane', '_blank');
  };

  const socialLinks = [
    {
      name: 'Discord',
      icon: 'ri-discord-fill',
      description: 'Join our community',
      members: '2.5K+',
      color: 'from-indigo-500 to-indigo-600',
      onClick: handleDiscordClick
    },
    {
      name: 'Twitter',
      icon: 'ri-twitter-x-fill',
      description: 'Follow for updates',
      members: '8.2K+',
      color: 'from-slate-600 to-slate-700',
      onClick: handleTwitterClick
    }
  ];

  return (
    <section className="py-24 px-6 relative">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-5xl md:text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-emerald-400 to-purple-400 mb-8">
            Ready to Join PSU?
          </h2>
          <div className="w-24 h-1 bg-gradient-to-r from-emerald-400 to-purple-400 mx-auto mb-8"></div>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Take the first step towards becoming a certified PSU streamer. Apply now or connect with our community.
          </p>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* CTA Section */}
          <div className="bg-gradient-to-br from-slate-800/50 to-slate-900/50 p-12 rounded-3xl border border-gray-700/50">
            <h3 className="text-3xl font-bold text-white mb-6">Start Your Journey</h3>
            <p className="text-gray-300 mb-8 leading-relaxed">
              Join hundreds of successful streamers who have already made PSU their home. Our application process is quick and straightforward.
            </p>

            <div className="space-y-4 mb-8">
              <div className="flex items-center">
                <div className="w-8 h-8 bg-emerald-500/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-emerald-400"></i>
                </div>
                <span className="text-gray-200">Quick 5-minute application</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-emerald-500/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-emerald-400"></i>
                </div>
                <span className="text-gray-200">Fast approval process (24-48 hours)</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-emerald-500/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-emerald-400"></i>
                </div>
                <span className="text-gray-200">Immediate access to community</span>
              </div>
              <div className="flex items-center">
                <div className="w-8 h-8 bg-emerald-500/20 rounded-full flex items-center justify-center mr-4">
                  <i className="ri-check-line text-emerald-400"></i>
                </div>
                <span className="text-gray-200">Start earning rewards right away</span>
              </div>
            </div>

            <button
              onClick={handleApplyClick}
              className="w-full group inline-flex items-center justify-center px-8 py-6 text-xl font-bold text-white bg-gradient-to-r from-emerald-600 to-purple-600 rounded-2xl hover:from-emerald-500 hover:to-purple-500 transform hover:scale-105 transition-all duration-300 shadow-2xl hover:shadow-emerald-500/25 whitespace-nowrap cursor-pointer"
            >
              <i className="ri-graduation-cap-fill mr-3 text-2xl"></i>
              Apply to Join PSU
              <i className="ri-arrow-right-line ml-3 text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          {/* Social Links */}
          <div className="space-y-6">
            <h3 className="text-3xl font-bold text-white mb-8">Connect With Us</h3>
            
            {socialLinks.map((social, index) => (
              <div key={index} className="group">
                <button
                  onClick={social.onClick}
                  className={`w-full p-6 rounded-2xl bg-gradient-to-r ${social.color} hover:scale-105 transition-all duration-300 text-left cursor-pointer`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center">
                      <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mr-4">
                        <i className={`${social.icon} text-2xl text-white`}></i>
                      </div>
                      <div>
                        <h4 className="text-xl font-bold text-white">{social.name}</h4>
                        <p className="text-white/80">{social.description}</p>
                      </div>
                    </div>
                    <div className="text-right">
                      <div className="text-white/80 text-sm">Members</div>
                      <div className="text-white font-bold text-lg">{social.members}</div>
                    </div>
                  </div>
                </button>
              </div>
            ))}

            {/* Contact info */}
            <div className="bg-gradient-to-r from-slate-800/30 to-slate-900/30 p-6 rounded-2xl border border-gray-700/30">
              <h4 className="text-xl font-bold text-white mb-4">Need Help?</h4>
              <div className="space-y-3">
                <div className="flex items-center">
                  <i className="ri-customer-service-2-fill text-emerald-400 mr-3"></i>
                  <span className="text-gray-300">24/7 Community Support</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-mail-fill text-purple-400 mr-3"></i>
                  <span className="text-gray-300">support@pumpstreameruniversity.com</span>
                </div>
                <div className="flex items-center">
                  <i className="ri-question-answer-fill text-emerald-400 mr-3"></i>
                  <span className="text-gray-300">FAQ & Knowledge Base</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
